import { Injectable } from '@angular/core';
import {
    Resolve,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';

import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CreepsService } from './creeps.service';

// import { ShardsDataSource } from './shards.data-source';

@Injectable()
export class CreepsResolver implements Resolve<IPowerCreep[]> {

    constructor(
        private _creepsService: CreepsService
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<IPowerCreep[]> {
        return from(this._creepsService.read())
            .pipe(map(({ list }) => list ));
    }
}
